// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Edit from "@flip/XDL/Icons/Edit";
import { createLinkIconStyles } from "@flip/XDL/Utilities/sharedStyles";
import { defaultBillingAddressStyles } from "@insite/content-library/Widgets/AccountSettings/DefaultBillingAddress";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

defaultBillingAddressStyles.headingText = {
    variant: "h4",
    css: css`
        margin-bottom: 5px;
    `,
};

defaultBillingAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        justify-content: space-between;
    `,
};

defaultBillingAddressStyles.editLink = {
    ...createLinkIconStyles(Edit, {
        typographyProps: {
            size: 12,
            lineHeight: "14px",
        },
        css: css`
            margin-top: 9px;
            margin-left: 30px;
            min-width: 70px;
            ${IconWrapper} {
                margin-right: 8px;
            }
        `,
    }),
};
